const DEFAULT_SUPABASE_URL = "https://jzhvqtgfdyhuminlzbnm.supabase.co";
const DEFAULT_SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp6aHZxdGdmZHlodW1pbmx6Ym5tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAwMjM4MjIsImV4cCI6MjA3NTU5OTgyMn0.KQOIp8EcGrnTj7jABegzDOx-iCBzX5dgxh1xE0EtBAo";

const envSupabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const envSupabaseAnon = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
const rawDisableAdminAuth = import.meta.env.VITE_DISABLE_ADMIN_AUTH?.trim();

const disableAdminAuth =
  rawDisableAdminAuth === undefined ? true : rawDisableAdminAuth === "true";

const supabaseUrl = envSupabaseUrl || DEFAULT_SUPABASE_URL;
const supabaseAnon = envSupabaseAnon || DEFAULT_SUPABASE_ANON_KEY;

export const ENV = {
  SUPABASE_URL: supabaseUrl,
  SUPABASE_ANON: supabaseAnon,
  READY: Boolean(supabaseUrl && supabaseAnon),
  HAS_CUSTOM_SUPABASE_CONFIG: Boolean(envSupabaseUrl && envSupabaseAnon),
  USING_DEFAULT_SUPABASE: !(envSupabaseUrl && envSupabaseAnon),
  ADMIN_AUTH_DISABLED: disableAdminAuth,
};

export const DEFAULTS = {
  SUPABASE_URL: DEFAULT_SUPABASE_URL,
  SUPABASE_ANON_KEY: DEFAULT_SUPABASE_ANON_KEY,
};
